module.exports = __webpack_public_path__ + "assets/383b3cfe0728e8b3a64f140b5313af15.mp3";